import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-card" }
const _hoisted_2 = { class: "container-card__head" }
const _hoisted_3 = { class: "container-card__head-content" }
const _hoisted_4 = { class: "container-card__title-content" }
const _hoisted_5 = { class: "container-card__title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "container-card__subtitle" }
const _hoisted_8 = { class: "container-card__alerts-insights" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "container-card__selects" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_select_monitoring_alert = _resolveComponent("select-monitoring-alert")!
  const _component_be_max_modal = _resolveComponent("be-max-modal")!
  const _component_nave_select = _resolveComponent("nave-select")!
  const _component_date_range = _resolveComponent("date-range")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "tipbar"),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "logo"),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, [
              _createElementVNode("span", { innerHTML: _ctx.title }, null, 8, _hoisted_6),
              (_ctx.tooltip)
                ? (_openBlock(), _createBlock(_component_tooltip, {
                    key: 0,
                    title: _ctx.tooltip,
                    html: _ctx.html
                  }, null, 8, ["title", "html"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("h2", _hoisted_7, [
              _renderSlot(_ctx.$slots, "subtitle")
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.alerts.length > 0)
                ? (_openBlock(), _createBlock(_component_select_monitoring_alert, {
                    key: 0,
                    title: _ctx.title,
                    alerts: _ctx.alerts
                  }, null, 8, ["title", "alerts"]))
                : _createCommentVNode("", true),
              _createVNode(_component_be_max_modal, {
                beMax: _ctx.beMax,
                mode: "line"
              }, null, 8, ["beMax"])
            ])
          ]),
          (_ctx.linkUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.linkUrl,
                target: "_blank",
                class: "container-card__link"
              }, [
                _createTextVNode(_toDisplayString(_ctx.linkText) + " ", 1),
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.linkIcon)
                }, null, 2)
              ], 8, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.checkOptions)
            ? (_openBlock(), _createBlock(_component_nave_select, {
                key: 0,
                options: _ctx.selectOptions,
                onOptionSelected: _ctx.optionSelected
              }, null, 8, ["options", "onOptionSelected"]))
            : _createCommentVNode("", true),
          (_ctx.checkDate)
            ? (_openBlock(), _createBlock(_component_date_range, {
                key: 1,
                time: _ctx.datePeriod,
                onDateUpdated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateDate($event)))
              }, null, 8, ["time"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}